// 服务模块入口文件
// 初始化HTTP拦截器
import { setupInterceptors } from './interceptors';

// 初始化拦截器
setupInterceptors();

// 导出所有API服务
export * from './api';

// 导出HTTP客户端
export { httpClient } from './http';

// 导出拦截器
export * from './interceptors';
